<template>
  <v-app>
    <popup-message ref="msg" />

    <v-app-bar app absolute flat style="background: radial-gradient(circle at top, #fafcfd, #b3dcffa1 100%)"><!-- #005eb84d -->
      <v-app-bar-nav-icon>
        <v-icon color="tp_blue_grey" @click.stop="drawer = !drawer">menu</v-icon>
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-toolbar-title class="mx-auto">
        <router-link to="/home">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-img v-on="on" src="@/assets/transpress-logo.png" contain position="center center" max-height="42" />
            </template>
            {{ $t('Home') }}
          </v-tooltip>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small text color="tp_blue_grey">
            <v-icon>tune</v-icon>
            <span class="caption" :title="$t('Menu')">
              {{ $t('Menu') }}
            </span>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item dense style="height: 2em">
            <span class="tp_blue--text caption">
              {{ $t('Navigation') }}
            </span>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item v-for="item in menuItems" :key="item.value"
            active-class="primary white--text"
            :to="item.to ? item.to : null"
            :href="item.href ? item.href : null"
            @click="item.onClick ? item.onClick() : null"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>translate</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <v-select
                  @click.stop
                  hide-details
                  :label="$t('Language')"
                  :items="langItems"
                  v-model="lang"
                ></v-select>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <div class="body-1 font-weight-light grey--text pa-2">
            {{ versionInfo }}
          </div>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-content app>
      <router-view
        class="container--fluid"
        :class="{'px-10': $vuetify.breakpoint.lgAndUp}"
      />
    </v-content>
  </v-app>

</template>

<script>
import PopupMessage from '@/components/PopupMessage';
import lang from '@/lang';

export default {
  name: 'Layout',
  components: {
    PopupMessage
  },
  data() {
    return {
      drawer: false,
      loading: false,
      menuItems: [
        { name: 'Website',         icon: 'link',  title: this.$t('Website'),        href: '//www.transpress.bg' },
        { name: 'ClientCabinet',   icon: 'apps',  title: this.$t('Client Cabinet'), href: '//app.transpress.bg/clients/' },
      ],
      lang: this.getLang(),
    }
  },
  computed: {
    versionInfo() {
      return this.$t('Version') + " " + process.env.VUE_APP_VERSION + " #" + process.env.VUE_APP_GIT_COMMIT_ID + " " + process.env.VUE_APP_GIT_COMMIT_DATE;
    },
    langItems() {
      return this.getLangs().map(elem => {
        return {
          text: this.$t('LANG.' + elem),
          value: elem
        }
      });
    }
  },
  methods: {
    ...lang
  },
  watch: {
    lang(val) {
      this.setLang(val);
    }
  }
}
</script>
